import { Movax } from './Movax';

// jquery does not currently support es6 way of importing so we need to do it old school
var $ = require('jquery');

export class Hero {
	private jsBlock: string;
	private block: string;
	private imageLoaded: boolean;

	private $holder;
	private $image;
  private $video;

	constructor(blockSelector:string) {
    var self = this;

		this.jsBlock = 'js-' + blockSelector;
		this.block = blockSelector;

    this.$holder = $('#' + this.jsBlock);

    this.$video = $('#' + this.jsBlock + '__video');

		this.imageLoaded = false;

		// if hero is found
		if(this.$holder) {

      this.$image = this.$holder.find('.' + this.jsBlock + '__image');

			if(!this.$image) {
				throw new Error('Hero#constructor: .' + this.jsBlock + '__image element not found');
			}

			if(Movax.breakpoints.getBreakpoint('general') === 'desktop') {

				this._loadFullResolutionImage();
				//console.log('desktop hero image');
			} else {

				// if lodaded in mobile breakpoint, listen for a change to desktop
				this._addBreakpointSubscriber();
			}

      if(this.$video.length) {
        Movax.dom.waitForVisibility(this.$video[0]).then(function() {
          self.$video.html(self.$video.data('video-html'));
        });
      }
		}
	}

	private _loadFullResolutionImage() {
		var imageSrc = this.$image.data('full-image'),
				preloadImage = new Image();

		document.createElement('img');

		if(imageSrc) {

			// preload image first to avoid flashing
			Movax.images.preloadImages([imageSrc], () => {
				this.$image.css({
					backgroundImage: 'url(' + imageSrc + ')'
				});


				this.$image.removeClass(this.block + '__image--blurred');

				//console.log('image preloaded');
			});
		}
	}

	private _addBreakpointSubscriber() {
		var breakpointSubscriber: (newBreakpoint:string, oldBreakpoint:string) => void;

		breakpointSubscriber = function(newBreakpoint, oldBreakpoint) {
			if (newBreakpoint === 'desktop') {
				//console.log('hero changed to desktop');
				Movax.breakpoints.removeChangeSubscriber(breakpointSubscriber);
			}
		}

		Movax.breakpoints.addChangeSubscriber(breakpointSubscriber, 'general');
	}
}
